<template>
  <b-container fluid>
    <div>
      <div class="d-flex flex-column">
  <HeaderSearch from="Demandes" @sac-customer-selected="onSacCustomerSelected"></HeaderSearch>
      </div>
      <div class="font_size_0_7">
        <b-table
          responsive
          hover
          striped
          :items="items"
          :fields="fields"
          :busy="isBusy"
          show-empty
          emptyText="Il n'y a pas d'échantillon"
        >
          <template #cell(CENT_TYP)="data">
            <span v-if="data.item.CENT_TYP === 2"> DLC </span>
            <span v-else-if="data.item.CENT_TYP === 3"> J+ </span>
            <span v-else> Jour </span>
          </template>
          <template #cell(EDIT)="data">
            <b-button
              v-if="data.item.CENT_ECH == null"
              size="sm"
              variant="outline-primary"
              class="font_size_0_7"
              @click="showModal('edit', data)"
            >
              Modifier
            </b-button>
          </template>

          <template #cell(DELETE)="data">
            <b-button
              v-if="data.item.CENT_ECH == null"
              size="sm"
              variant="outline-secondary"
              class="font_size_0_7"
              @click="showModalDelete(data)"
            >
              Supprimer
            </b-button>
          </template>

          <div slot="table-busy" class="text-center">
            <b-spinner class="align-middle color_green_labco" type="grow" />
          </div>
        </b-table>
        <b-row v-if="items != null && totalItems > perPage">
          <b-col md="12">
            <b-pagination
              :total-rows="totalItems"
              :per-page="perPage"
              v-model="currentPage"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>

      <!-- MODAL -->
      <b-modal
        id="modelStep"
        v-on:closeModel="hideModel"
        ref="my-modal"
        size="xl"
        hide-footer
        @hidden="hiddenModal"
        no-close-on-backdrop
        :title="titleModalForm"
      >
        <DetailEchantillonComponent
          :itemsAnalyse="items"
          :modeEdition="modeEdition"
          :itemEdit="itemEdit"
          :numRapport="items"
        >
        </DetailEchantillonComponent>
      </b-modal>

      <!-- MODAL -->
      <b-modal
        v-model="modalDeleteShown"
        v-if="itemToDelete != null"
        scrollable
        size="lg"
        title="Voulez-vous vraiment supprimer cette analyse ?"
      >
        <b>{{ itemToDelete.CENT_LIB }}</b
        ><br />
        <small
          >Date de prélèvement : {{ itemToDelete.CENT_DATPRLT }}<br />
          Date souhaitée : {{ itemToDelete.CENT_DATSOUHAIT }}</small
        >

        <template v-for="(error, i) in msgsErrorDelete">
          <b-alert
            show
            variant="warning"
            class="mt-2"
            v-html="error.message"
            :key="i"
          ></b-alert>
        </template>
        <template v-if="msgSuccessDelete != ''">
          <b-alert
            show
            variant="success"
            class="mt-2"
            v-html="msgSuccessDelete"
          ></b-alert>
        </template>

        <template v-slot:modal-footer>
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            @click="modalDeleteShown = false"
          >
            Annuler
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            class="float-right"
            @click="deleteEchantillon"
          >
            Oui, effacer
          </b-button>
        </template>
      </b-modal>
    </div>
  </b-container>
</template>

<script>
import moment from 'moment'
import api from './../api.js'
import DetailEchantillonComponent from './DetailEchantillonComponent'
import HeaderSearch from './HeaderSearchComponent'

export default {
  name: 'NewEnregistrementComponent',
  components: {
    DetailEchantillonComponent, HeaderSearch
  },
  data () {
    return {
      isSac: false,
      itemsAll: [],
      sacCustomerFilter: null,
      enregistrement: {},
      analyse: {},
      products: null,
      idFamily: 8,
      fields: [],
      items: [],
      oldCol: true,
      newCol: true,
      oldCol2: false,
      newCol2: false,
      index: 1,
      isBusy: true,
      perPage: 50,
      currentPage: 1,
      totalItems: 0,
      // search tools
      selected: 'dateDbtFin',
      tri: '',
      nbreJour: 30,
      jourDisabled: false,
      echantillonDisable: true,
      echantillonFilter: null,
      disableRadio: false,
      dateDisable: false,
      dateDebut: moment().subtract(30, 'days').format('YYYY-MM-DD'),
      dateFin: moment().format('YYYY-MM-DD'),
      dateMax: moment().format('YYYY-MM-DD'),
      isHide: true,
      select: false,

      modeEdition: 'create',
      itemEdit: null,
      itemToDelete: null,
      modalDeleteShown: false,
      msgsErrorDelete: [],
      msgSuccessDelete: ''
    }
  },
  methods: {
    hiddenModal: function () {
      const vm = this

      vm.getEnregistrementByClient()
    },
    hideModel () {
      this.$refs['my-modal'].hide()
    },
    getResultsForRangeDates () {
      setTimeout(() => { this.getEnregistrementByClient() }, 0)
    },
    getProduct () {
      this.isBusy = true
      const vm = this
      api.getProductsByClient(this.$root.user.login)
        .done(function (data) {
          vm.products = data.products
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function () {
          vm.isBusy = false
        })
    },
    getProductsGenerik () {
      this.isBusy = true
      const vm = this
      api.getProductsGenerikByClient(this.$root.user.login)
        .done(function (data) {
          vm.products = data.products
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function (xhr) {
          vm.isBusy = true
        })
    },
    onSacCustomerSelected (value) {
      // value is the selected client identifier (e.g. CLT_NUM) or null
      this.sacCustomerFilter = value
      // reset to first page when filter changes
      this.currentPage = 1
      // apply filter locally (only meaningful when isSac)
      this.applySacFilter(true)
    },
    applySacFilter (resetPage = false) {
      // If not SAC, simply mirror server data (server handles pagination)
      if (!this.isSac) {
        this.items = Array.isArray(this.itemsAll) ? this.itemsAll.slice() : []
        this.totalItems = Array.isArray(this.itemsAll) ? this.itemsAll.length : 0
        return
      }

      // determine filtered list
      let filtered = this.itemsAll || []
      if (this.sacCustomerFilter) {
        const filterVal = this.sacCustomerFilter
        filtered = filtered.filter(item => {
          return (item.CENT_CLT && String(item.CENT_CLT) === String(filterVal)) ||
                 (item.CLT_NUM && String(item.CLT_NUM) === String(filterVal)) ||
                 (item.CENT_NUM && String(item.CENT_NUM) === String(filterVal))
        })
      }

      // update totalItems based on filtered length
      this.totalItems = filtered.length

      // ensure currentPage valid
      if (resetPage) {
        this.currentPage = 1
      }

      // slice according to pagination (50 per page enforced)
      const perPage = this.perPage || 50
      const start = (this.currentPage - 1) * perPage
      const end = start + perPage
      this.items = filtered.slice(start, end)
    },
    getFamilyByClient () {
      this.isBusy = true
      const vm = this
      api.getFamilyByClient(this.$root.user.login)
        .done(function (data) {
          vm.products = data.products
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function (xhr) {
          vm.isBusy = true
        })
    },
    getEnregistrementByClient () {
      const vm = this

      vm.isBusy = true
      let select = vm.select === false ? 0 : 1
      // If SAC, fetch all records in one request so we can filter/paginate locally
      const reqPage = vm.isSac ? 1 : vm.currentPage
      const reqLimite = vm.isSac ? 1000000 : vm.perPage
      api.getEnregistrementByClient(vm.$root.user.login, vm.dateDbt, vm.dateFin, select, reqPage, reqLimite)
        .done((data) => {
          // keep full list so we can apply a local filter
          vm.itemsAll = data.enregistrements || []

          // If running in SAC mode, sort itemsAll by CENT_RSO then CENT_LIB (ascending)
          if (vm.isSac && Array.isArray(vm.itemsAll)) {
            vm.itemsAll.sort((a, b) => {
              const rsoA = (a && a.CENT_RSO) ? String(a.CENT_RSO) : ''
              const rsoB = (b && b.CENT_RSO) ? String(b.CENT_RSO) : ''
              if (rsoA !== rsoB) return rsoA.localeCompare(rsoB, 'fr', { sensitivity: 'base' })
              const libA = (a && a.CENT_LIB) ? String(a.CENT_LIB) : ''
              const libB = (b && b.CENT_LIB) ? String(b.CENT_LIB) : ''
              return libA.localeCompare(libB, 'fr', { sensitivity: 'base' })
            })
          }

          // apply local SAC customer filter if set (this will set totalItems and items slice)
          vm.applySacFilter(true)

          vm.totalItems = data.total
        })
        .fail(function (xhr) {
          window.fail(xhr, true)
        })
        .always(function () {
          vm.isBusy = false
        })
    },
    displayTable () {
      if (this.isSac) {
        this.fields = [
          {
            key: 'NEWCOLUMN',
            label: '',
            sortable: false
          },
          {
            key: 'CENT_CECH',
            label: 'Code Echantillon',
            sortable: false
          },
          {
            key: 'CENT_RSO',
            label: 'Client',
            sortable: false
          },
          {
            key: 'CENT_LIB',
            label: 'Produit',
            sortable: false
          },
          {
            key: 'CENT_NRAP',
            label: 'Numéro de rapport ',
            sortable: false
          },
          {
            key: 'CENT_FAM.CFAM_LIB',
            label: 'Famille',
            sortable: false
          },
          {
            key: 'CENT_TYP',
            label: 'Type Analyse',
            sortable: false
          },
          {
            key: 'CENT_NBJ',
            label: 'Analyse à J+',
            sortable: false
          },
          {
            key: 'CENT_DATPRLT',
            label: 'Date prélèvement',
            sortable: false
          },
          {
            key: 'CENT_DATDLC',
            label: 'DLC',
            sortable: false
          },
          {
            key: 'CENT_DATFAB',
            label: 'Date Fabrication',
            sortable: false
          },
          {
            key: 'CENT_DATSOUHAIT',
            label: 'Date Dispo Labo',
            sortable: false
          },
          {
            key: 'EDIT',
            label: 'Modifier',
            sortable: false
          },
          {
            key: 'DELETE',
            label: 'Effacer',
            sortable: false
          }
        ]
      } else {
        this.fields = [
          {
            key: 'NEWCOLUMN',
            label: '',
            sortable: false
          },
          {
            key: 'CENT_CECH',
            label: 'Code Echantillon',
            sortable: false
          },
          {
            key: 'CENT_LIB',
            label: 'Produit',
            sortable: false
          },
          {
            key: 'CENT_NRAP',
            label: 'Numéro de rapport ',
            sortable: false
          },
          {
            key: 'CENT_FAM.CFAM_LIB',
            label: 'Famille',
            sortable: false
          },
          {
            key: 'CENT_TXT3',
            label: 'N° Lot',
            sortable: false
          },
          {
            key: 'CENT_COD_CLT',
            label: 'Code Produit',
            sortable: false
          },
          {
            key: 'CENT_TXT1',
            label: 'Ref Client',
            sortable: false
          },
          {
            key: 'CENT_TXT2',
            label: 'Ref Fournisseur',
            sortable: false
          },
          {
            key: 'CENT_TYP',
            label: 'Type Analyse',
            sortable: false
          },
          {
            key: 'CENT_NBJ',
            label: 'Analyse à J+',
            sortable: false
          },
          {
            key: 'CENT_DATPRLT',
            label: 'Date prélèvement',
            sortable: false
          },
          {
            key: 'CENT_DATDLC',
            label: 'DLC',
            sortable: false
          },
          {
            key: 'CENT_DATFAB',
            label: 'Date Fabrication',
            sortable: false
          },
          {
            key: 'CENT_DATSOUHAIT',
            label: 'Date Dispo Labo',
            sortable: false
          },
          {
            key: 'EDIT',
            label: 'Modifier',
            sortable: false
          },
          {
            key: 'DELETE',
            label: 'Effacer',
            sortable: false
          }
        ]
      }
    },
    addRow (index, item) {
      this.oldCol = true
      this.newCol = false
      this.oldCol2 = false
      this.newCol2 = true
      this.index = this.index + 1
    },
    showModalInfoEchantillon () {
      this.$refs['modalInfoEchantillon'].show()
    },
    deleteEchantillon () {
      let date = this.itemToDelete.CENT_ANN + '-' + this.itemToDelete.CENT_MOI + '-' + this.itemToDelete.CENT_JOU
      if (this.$root.user.login === 907 || this.$root.user.login === 9999) {
        api.deleteEchantillonSac(date, this.itemToDelete.CENT_NUM, this.itemToDelete.CENT_CLT)
          .done((data) => {
            this.msgsErrorDelete = []
            this.msgSuccessDelete = 'L\'analyse a bien été supprimée'
            setTimeout(() => {
              this.msgSuccessDelete = ''
              this.modalDeleteShown = false
              this.getEnregistrementByClient()
            }, 2000)
          })
          .fail((xhr) => {
            this.msgsErrorDelete = xhr.responseJSON.erreurs
            this.msgSuccessDelete = ''
          })
      } else {
        api.deleteEchantillon(date, this.itemToDelete.CENT_NUM)
          .done((data) => {
            this.msgsErrorDelete = []
            this.msgSuccessDelete = 'L\'analyse a bien été supprimée'
            setTimeout(() => {
              this.msgSuccessDelete = ''
              this.modalDeleteShown = false
              this.getEnregistrementByClient()
            }, 2000)
          })
          .fail((xhr) => {
            this.msgsErrorDelete = xhr.responseJSON.erreurs
            this.msgSuccessDelete = ''
          })
      }
    },
    showModal (modeEdition, data) {
      this.modeEdition = modeEdition
      this.itemEdit = data != null ? data.item : null
      this.$refs['my-modal'].show()
    },
    hideModal (enregistrement) {
      this.$refs['my-modal'].hide()
      this.items.push(enregistrement)
    },
    runExport () {
      let s = this.select === true ? 1 : 0
      api.getEnregistrementByClient(this.$root.user.login, this.dateDbt, this.dateFin, s, 1, 50, 'csv')
        .done((data) => {
          this.downloadFile(data, 'demandesAnalyses')
        })
        .fail((xhr) => {
          window.fail(xhr, true)
        })
    },
    downloadFile (csv, fileName) {
      var blob = new Blob(['\ufeff', csv])
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${fileName}.csv`)
      document.body.appendChild(link)
      link.click()
    },
    showModalDelete (data) {
      this.itemToDelete = data.item
      this.modalDeleteShown = true
      this.msgsErrorDelete = []
      this.msgSuccessDelete = ''
    }
  },
  created: function (params) {
    this.isSac = (this.$root.user.login === 907 || this.$root.user.login === 9999)
    this.getEnregistrementByClient()
    this.displayTable()
  },
  mounted: function (data) {
    global.model1 = this.$refs['my-modal']
    this.items = [
      {
        ECHANTILLON: ''
      }
    ]
  },
  watch: {
    selected: function () {
      if (this.selected !== 'echantillon') {
        this.echantillonDisable = true
        this.isHide = false
      } else {
        this.echantillonDisable = false
      }

      if (this.selected !== 'dateDbtFin') {
        this.dateDisable = true
        this.isHide = true
      } else {
        this.dateDisable = false
      }
    },
    currentPage: function () {
      if (this.isSac) {
        // local pagination
        this.applySacFilter(false)
      } else {
        this.getResultsForRangeDates()
      }
    }
  },
  computed: {
    dateDbt: function () {
      if (this.dateDebut === '') {
        return moment().subtract(this.nbreJour, 'days').format('YYYY-MM-DD')
      } else {
        return this.dateDebut
      }
    },
    titleModalForm () {
      return this.modeEdition === 'create'
        ? 'Demande d\'analyse : nouvel échantillon'
        : 'Demande d\'analyse : modification échantillon'
    }
  }
}
</script>


<style>
.button_ajout_style:hover {
  background-color: #ffffff;
  border-color: #89c338;
  color: #2083bc;
}

.button_ajout_style {
  background-color: #f7931e;
  border-color: #2083bc 1px solid;
  border-radius: 0px 20px 0px 20px !important;
}

.modal-title {
  color: #157885;
}
</style>



// WEBPACK FOOTER //
// src/components/NewEnregistrementComponent.vue